module.exports = {"message":"hello i18n !!"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/yew.json
// module id = 359
// module chunks = 43